// extracted by mini-css-extract-plugin
export var light = "subtitle-module--light--mbj6U";
export var subtitle = "subtitle-module--subtitle--3KqOb";